import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ModalSupportUrlText = styled.span`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${34 * Screen.widthRatio}px;
  margin: ${40 * Screen.widthRatio}px auto 0 auto;
  text-align: center;
  width: fit-content;
`;

export default ModalSupportUrlText;
